import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { LoadingState } from '../components/LoadingState';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const auth = useAuth();

  if (auth.isLoading) {
    return <div className="container-fluid px-3 px-lg-4 py-4"><LoadingState label="Checking session" /></div>;
  }

  if (!auth.isAuthenticated) {
    return (
      <div className="container py-5">
        <div className="card shadow-sm mx-auto" style={{ maxWidth: '42rem' }}>
          <div className="card-body p-4">
            <h1 className="h3">Sign in required</h1>
            <p className="text-body-secondary">Server management requires an administrator account.</p>
            <button className="btn btn-primary" type="button" onClick={auth.login}>
              <i className="bi bi-discord me-2" /> Sign in with Discord
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!auth.isAdmin) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning shadow-sm" role="alert">
          <div className="fw-semibold">Admin access required</div>
          <div>Your account is signed in, but it does not have access to this dashboard.</div>
          <Link className="alert-link" to="/">Return home</Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
